/* global localStorage */
import React, { useEffect } from 'react'
import { useValues, useActions } from 'kea'
import { router } from 'kea-router'

import I18n from 'lib/i18n'
import Float from 'lib/tags/float'
import FullScreen from 'lib/components/full-screen'
import EscToClose from 'lib/components/esc-to-close'
import OfflineToggleMode from 'lib/components/offline-toggle-mode'

import Header from './header'
import StartMessage from './start-message'
import ContentMarketing from './content-marketing'

import Breadcrumbs from './breadcrumbs'
import Map from './map'
import FavouritesHeader from './favourites-header'
import FavouritesButton from './favourites-button'
import LessonReviews from './lesson-reviews'
import Buckets from './buckets'
import Results from './results'

import sceneLogic from '../logic'
import filtersLogic from '~/scenes/search/filters-page/logic'
import MobileBreadcrumb from './mobile-breadcrumb'
import TeacherCount from './teacher-count'
import FaqAccordion from './content-marketing/faq-accordion'

import mapIcon from './assets/map-icon.svg'

export default function SearchPage () {
  const {
    showStartMessage,
    showStartMessageOnLogOff,
    isLandingPage,
    isLandingPageOnLogOff,
    hasBreadcrumbs,
    results,
    showMap,
    showingFavourites,
    isFullScreenMap,
    cleanContentBeforeReviews,
    cleanContentAfterReviews,
    searchPageFaqs,
    faqsTitle
  } = useValues(sceneLogic)

  const { openFilter, applyFilter } = useActions(filtersLogic)

  const { buckets, reviews, page } = results
  const showContentBeforeReviews = (showStartMessageOnLogOff || showStartMessage) && !!cleanContentAfterReviews.length

  useEffect(() => {
    let handled = false

    const handleBackFromOnlineLandingPages = () => {
      if (handled) return
      const from = localStorage.getItem('redirectFromActivityLandingPage')
      if (from && page === 1) {
        handled = true
        localStorage.removeItem('redirectFromActivityLandingPage')
        router.actions.replace(from)
      }
    }

    window.addEventListener('popstate', handleBackFromOnlineLandingPages)

    return () => window.removeEventListener('popstate', handleBackFromOnlineLandingPages)
  }, [page])

  return (
    <div className={`search-page${isLandingPageOnLogOff || isLandingPage ? ' with-cover-photo' : ''}`}>
      {isFullScreenMap ? <FullScreen /> : null}
      <EscToClose onEsc={applyFilter} />

      <Header />

      {!isFullScreenMap && showingFavourites ? <FavouritesHeader /> : null}
      {(!isFullScreenMap && showStartMessageOnLogOff) || showStartMessage ? <StartMessage /> : null}

      <div className='grid responsive-full-grid search-breadcrumbs-map-results'>
        {!isFullScreenMap && hasBreadcrumbs ? (
          <div className='only-large-screen'>
            <Breadcrumbs />
          </div>
        ) : null}

        {showMap && (
          <div className={`col-1-3 base-map-div grid-breakout${isFullScreenMap ? ' active' : ''}`}>
            <Float otherId='main-search-results' fromHeight={121}>
              <div className={`search-page-map${isFullScreenMap ? ' with-full-screen-map' : ''}`}>
                <FavouritesButton />
                <div dir='ltr' className='map-component'>
                  <Map />
                </div>
                <div className='map-mobile-click-area' onClick={() => openFilter('map')} />
              </div>
            </Float>
          </div>
        )}

        {!isFullScreenMap && hasBreadcrumbs ? (
          <div className='except-large-screen'>
            <TeacherCount />
          </div>
        ) : null}

        {!isFullScreenMap ? <Results id='main-search-results' /> : null}
      </div>

      {!isFullScreenMap ? (
        <div className='search-page-bottom'>
          {(showStartMessageOnLogOff || showStartMessage) && !!cleanContentBeforeReviews.length ? (
            <ContentMarketing contents={cleanContentBeforeReviews} />
          ) : null}
          {!showingFavourites && reviews && reviews.length > 0 ? <LessonReviews /> : null}
          <div className='except-large-screen'>
            <MobileBreadcrumb />
          </div>

          {(showStartMessageOnLogOff || showStartMessage) && !!searchPageFaqs.length ? (
            <FaqAccordion
              contents={searchPageFaqs}
              hasContentAfterReviews={showContentBeforeReviews}
              title={faqsTitle}
            />
          ) : null}

          {showContentBeforeReviews ? <ContentMarketing contents={cleanContentAfterReviews} /> : null}
          {!showingFavourites && buckets ? (
            <div>
              {buckets.city ? <Buckets buckets={buckets.city} /> : null}
              {buckets.category ? <Buckets buckets={buckets.category} /> : null}
              {buckets.country ? <Buckets buckets={buckets.country} /> : null}
              {buckets.nearby_city ? <Buckets buckets={buckets.nearby_city} /> : null}
            </div>
          ) : null}
        </div>
      ) : null}
      {!isFullScreenMap && (
        <div className='map-mobile-click-area' onClick={() => openFilter('map')}>
          <img className='map-icon' src={`${mapIcon}`} height='20' width='20' alt='map icon' />
          <span className='map-text'>{I18n.t('react.search.filters.map')}</span>
        </div>
      )}
      <OfflineToggleMode />
    </div>
  )
}
